/* eslint-disable */
import axios from 'axios'
import authService from '../services/authService'
import { MyAxiosRequestConfig } from './types'
import jwtDecode from 'jwt-decode'
import authUrlConstnts from '../constants/authUrlConstnts'

export interface IAuthJWT {
  token_type: string
  exp: number
  iat: number
  jti: string
  user_id: string
  type: string
  roles: string[]
}

const axiosInstance = axios.create()

axiosInstance.interceptors.response.use(undefined, async err => {
  // check if status is 401 user is unauthorized
  if (err.response?.status === 401 && err.response.data.code === 'token_not_valid') {
    const refreshToken = localStorage.getItem('refreshToken')

    if (refreshToken) {
      const tokenData: IAuthJWT = jwtDecode(refreshToken)
      const expirationTime = new Date(tokenData?.exp * 1000)
      const currentTime = new Date()
      if (expirationTime < currentTime) {
        localStorage.removeItem('accessToken')
        localStorage.removeItem('refreshToken')
        window.location.pathname = '/login'
        return
      }
      try {
        const { data } = await authService.refreshToken(refreshToken)
        localStorage.setItem('accessToken', data.access)
      } catch (error) {}
    }

    localStorage.removeItem('token')
    // navigate user to login page
    if (window.location.pathname !== '/login') window.location.pathname = '/login'
  }

  // when user attemps to get forbidden resource
  if (err?.response?.status === 403) {
    window.location.pathname = '/forbidden'
  }

  return Promise.reject(err)
})

axiosInstance.interceptors.request.use((requestConfig: MyAxiosRequestConfig) => {
  const token = localStorage.getItem('accessToken')
  if (requestConfig.url === `${authUrlConstnts.REFRESH_TOKEN_URL}`) {
    return requestConfig
  }
  requestConfig.headers.Authorization = `Bearer ${token}`

  return requestConfig
})

export default axiosInstance
